"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function RecentChroniclesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 animate-pulse">
            <AspectRatio ratio={2 / 3} className="bg-muted rounded-xl overflow-hidden" />
            <div className="space-y-2">
              <div className="h-5 bg-muted rounded w-3/4"></div>
              <div className="h-4 bg-muted rounded w-1/2"></div>
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 border border-destructive/20 rounded-xl bg-destructive/5">
        <p className="text-destructive mb-4">Failed to load latest insights.</p>
        <Button variant="outline" onClick={() => window.location.reload()}>Retry</Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>No articles available yet.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {posts.map((post, i) => {
      const chapterMatch = post.title.match(/\d+/);
      const chapterText = chapterMatch ? `READ` : "GUIDE";
      const releaseDate = post.date ? new Date(post.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }) : "New Release";
      return <div key={post.id} data-index={i} className="flex flex-col gap-4 group">
            <Link to={post.link || "#"} className="block relative overflow-hidden rounded-xl bg-card border border-border/50 transition-all duration-500 hover:shadow-xl">
              <AspectRatio ratio={2 / 3}>
                {}
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/editorial_wellness_cover.png"} alt={post.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                
                {}
                <div className="absolute inset-0 pointer-events-none z-10 opacity-5 mix-blend-overlay" style={{
              backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #000 2px, #000 4px)'
            }} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 via-transparent to-transparent z-10" />

                {}
                <div className="absolute inset-0 flex items-center justify-center bg-background/60 opacity-0 group-hover:opacity-100 transition-all duration-500 z-20 backdrop-blur-sm">
                  <span className="text-4xl md:text-5xl font-bold text-primary scale-75 group-hover:scale-100 transition-transform duration-500 font-default tracking-tighter">
                    {chapterText}
                  </span>
                </div>
              </AspectRatio>
            </Link>
            
            <div className="flex flex-col gap-1 px-1">
              <h3 className="text-foreground font-semibold text-lg md:text-xl font-default line-clamp-1 group-hover:text-primary transition-colors duration-300">
                <Link to={post.link || "#"}>{post.title}</Link>
              </h3>
              <p className="text-muted-foreground text-sm uppercase tracking-widest font-mono">
                {releaseDate}
              </p>
            </div>
          </div>;
    })}
    </div>;
}
export default function RecentChronicles() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="223584" id="the-playbook" className="bg-secondary text-foreground py-20 px-4 md:px-8 lg:px-12 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col items-center justify-between mb-12 gap-6 md:flex-row md:items-end">
          <div className="space-y-2 text-center md:text-left">
            <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tight uppercase">
              The <span className="text-primary">Playbook</span>
            </h2>
            <p className="text-muted-foreground max-w-xl font-default text-lg">
              Curated editorial insights on wellness, intimacy, and modern connection. Explore our latest field reports.
            </p>
          </div>
          <Button asChild variant="outline" className="border-border hover:bg-primary/10 hover:text-primary hover:border-primary transition-colors rounded-md">
            <Link to="/HomePage">View All Articles</Link>
          </Button>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <RecentChroniclesConsumer />
        </PostsProvider>
      </div>
    </section>;
}